// components/LatestJobRunCell.jsx
import React from 'react';
import { Tooltip, Badge } from '@mui/material';
import { styled } from '@mui/material/styles';
import HtmlTooltip from '@/components/tooltip/HtmlTooltip';

const StyledBadge = styled(Badge, {
  shouldForwardProp: (prop) => prop !== 'color' && prop !== 'enableRipple',
})(({ theme, color, enableRipple }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: color,
    color: color,
    width: '15px',
    height: '15px',
    borderRadius: '50%',
    fontSize: '1rem',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      border: '1px solid currentColor',
      content: '""',
      ...(enableRipple
        ? { animation: 'ripple 1.2s infinite ease-in-out' }
        : {}),
    },
  },
  '@keyframes ripple': {
    '0%': { transform: 'scale(.8)', opacity: 1 },
    '100%': { transform: 'scale(2.4)', opacity: 0 },
  },
}));

const badgeContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
};

const statusConfig = {
  manual: {
    color: '#44b700',
    title: 'Manual Run Requested',
  },
  success: {
    color: '#44b700',
    title: 'Latest run completed',
    content: <div>Successfully generated weekplan</div>,
  },
  success_warnings: {
    color: 'orange',
    title: 'Latest run completed with warnings',
    // content: (warnings) => warnings.map((w, i) => <div key={i}>{w.message}</div>),
  },
  failed: {
    color: 'red',
    title: 'Latest run failed',
    // content: (errors) => errors.map((e, i) => <div key={i}>{e.message}</div>),
  },
  inactive_run: {
    color: 'grey',
    title: 'Inactive',
    content: <div>No recent runs.</div>,
  },
  inactive_no_run: {
    color: 'grey',
    title: 'Inactive',
    content: <div>No recent runs.</div>,
  },
  no_output: {
    color: 'default',
    title: 'No Output',
    content: (
      <span style={{ fontSize: '1rem' }}>
        Latest run produced no processable Output.
      </span>
    ),
  },
};

export default function SubscriptionLatestRunCell({
  status,
  warnings = [],
  errors = [],
}) {
  const cfg = statusConfig[status] ?? statusConfig.no_output;
  const content =
    status === 'success_warnings'
      ? warnings?.map((w, i) => <div key={i}>{w?.message}</div>)
      : status === 'failed'
      ? errors?.map((e, i) => <div key={i}>{e?.message}</div>)
      : cfg.content;

  return (
    <div style={badgeContainerStyle}>
      <HtmlTooltip title={cfg.title} content={content} placement="right">
        <StyledBadge
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          variant="dot"
          color={cfg.color}
          enableRipple={false}
        />
      </HtmlTooltip>
    </div>
  );
}
